import React from 'react';

type StarIconProps = {
  filled: boolean;
  size?: number;
};

export const StarIcon: React.FC<StarIconProps> = ({ filled, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={filled ? '#1a4b8c' : 'none'}
    stroke="#1a4b8c"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
